import * as React from "react";
import * as Mui from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faBullhorn,
  faEnvelope,
  faHeart,
  faStar,
  faTasks,
  faPencil,
} from "@fortawesome/pro-light-svg-icons";
import {
  faCaretUp,
  faCaretRight,
  faCaretDown,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faWindows,
  faRedhat,
  faMicrosoft,
  faUbuntu,
  faLinux,
} from "@fortawesome/free-brands-svg-icons";
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import DatePicker from '@mui/lab/DatePicker';

const EngineerDashboardPage = () => {
  const [value, setValue] = React.useState<Date | null>(null);

  return (
    <>
      <Mui.Grid container spacing={2}>
        <Mui.Grid item xs={12} md={2}>
          <Mui.Box sx={{ width: "100%", maxWidth: 360 }}>
            <Mui.List aria-label="engineeringfunctions" sx={{ pt: 0 }}>
              {/* No idea why important is required, investigate */}
              <Mui.ListItemButton
                sx={{
                  backgroundColor: "#eee",
                  borderColor: "#bbb !important",
                  borderWidth: "1px !important",
                  border: "solid",
                  borderRadius: "10px",
                }}
              >
                <Mui.Avatar
                  sx={{
                    mr: 1,
                    width: "30px",
                    height: "30px",
                    backgroundColor: "purple",
                    fontSize: "0.8rem",
                  }}
                >
                  AD
                </Mui.Avatar>
                <Mui.ListItemText primary="Andrew Deakins" />
              </Mui.ListItemButton>

              <Mui.ListItemButton>
                <Mui.ListItemIcon>
                  <FontAwesomeIcon icon={faEnvelope} size="lg" />
                </Mui.ListItemIcon>
                <Mui.ListItemText primary="Your Messages" secondary="5 new" />
              </Mui.ListItemButton>

              <Mui.ListItemButton>
                <Mui.ListItemIcon>
                  <FontAwesomeIcon icon={faCalendar} size="lg" />
                </Mui.ListItemIcon>
                <Mui.ListItemText
                  primary="Your Task Calendar"
                  secondary="1 Task starting today"
                />
              </Mui.ListItemButton>
            </Mui.List>
            <Mui.List component="nav" aria-label="secondary mailbox folder">
              <Mui.ListItemText
                primary={
                  <Mui.Typography fontWeight="bold">My Forums</Mui.Typography>
                }
              />
              <Mui.ListItemButton
              //selected={selectedIndex === 2}
              //onClick={(event) => handleListItemClick(event, 2)}
              >
                <Mui.ListItemIcon>
                  <FontAwesomeIcon icon={faBullhorn} size="lg" />
                </Mui.ListItemIcon>
                <Mui.ListItemText
                  primary="Community 1"
                  secondary="5 recent posts"
                />
              </Mui.ListItemButton>
              <Mui.ListItemButton
              //selected={selectedIndex === 3}
              //onClick={(event) => handleListItemClick(event, 3)}
              >
                <Mui.ListItemIcon>
                  <FontAwesomeIcon icon={faBullhorn} size="lg" />
                </Mui.ListItemIcon>
                <Mui.ListItemText
                  primary="Community 2"
                  secondary="0 recent posts"
                />
              </Mui.ListItemButton>
              <Mui.ListItemButton>
                <Mui.ListItemIcon>
                  <FontAwesomeIcon icon={faBullhorn} size="lg" />
                </Mui.ListItemIcon>
                <Mui.ListItemText
                  primary="Community 3"
                  secondary="25 recent posts"
                />
              </Mui.ListItemButton>
              <Mui.ListItemButton>
                <Mui.ListItemIcon>
                  <FontAwesomeIcon icon={faBullhorn} size="lg" />
                </Mui.ListItemIcon>
                <Mui.ListItemText
                  primary="Community 4"
                  secondary="100 recent posts"
                />
              </Mui.ListItemButton>
              <Mui.ListItemText
                primary={
                  <Mui.Typography fontWeight="bold">Recent News</Mui.Typography>
                }
              />
            </Mui.List>
          </Mui.Box>
        </Mui.Grid>
        <Mui.Grid container spacing={2} item xs={12} md={10}>
          <Mui.Grid item xs={12} md={6}>
            <Mui.Box
              sx={{
                border: "solid 1px #ddd",
                height: "500px",
                boxShadow: "0 0 13px 0 rgb(74 53 107 / 8%)",
              }}
            >
              <Mui.Stack direction="column" sx={{ position: "relative" }}>
                <Mui.Box
                  sx={{ backgroundColor: "#0f6ebe", height: "300px" }}
                ></Mui.Box>
                <Mui.Box sx={{ paddingTop: "50px", paddingLeft: "30px" }}>
                  <Mui.Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    Andrew Deakins (Engineer)
                  </Mui.Typography>
                </Mui.Box>
                <Mui.Box sx={{ paddingTop: "50px", paddingLeft: "30px" }}>
                  <Mui.Stack
                    direction="row"
                    justifyContent={"flex-end"}
                    spacing={2}
                    marginRight={2}
                  >
                    <Mui.Badge color="error" badgeContent={10} max={999}>
                      <Mui.Button variant="outlined">New Messages</Mui.Button>
                    </Mui.Badge>
                    <Mui.Button variant="outlined">Recent Posts</Mui.Button>
                    <Mui.Button variant="outlined">New Messages</Mui.Button>
                  </Mui.Stack>
                </Mui.Box>
                <Mui.Avatar
                  sx={{
                    fontSize: "50px",
                    height: "170px",
                    width: "170px",
                    position: "absolute",
                    top: "170px",
                    left: "30px",
                    border: "solid",
                    borderWidth: "10px",
                    borderColor: "white",
                    backgroundColor: "purple",
                  }}
                  className="userSummaryAvatar"
                >
                  AD
                </Mui.Avatar>
              </Mui.Stack>
            </Mui.Box>
          </Mui.Grid>
          <Mui.Grid item xs={12} md={3}>
            <Mui.Stack
              direction="column"
              justifyContent="space-evenly"
              alignItems="stretch"
              height="100%"
              spacing={1}
            >
              <Mui.Box
                sx={{
                  backgroundColor: "rgb(238,123,94)",
                  background:
                    "linear-gradient(90deg, rgba(238,123,94,1) 0%, rgba(241,149,126,1) 100%)",
                  height: "48%",
                  borderRadius: "10px",
                  p: 2,
                  position: "relative",
                }}
              >
                <Mui.Stack direction="column">
                  <Mui.Typography color="#fcd9bb" fontSize={18}>
                    New Issues
                  </Mui.Typography>
                  <Mui.Typography
                    color="white"
                    variant="h4"
                    sx={{ pt: 2, pb: 2 }}
                  >
                    20
                  </Mui.Typography>
                  <Mui.Box sx={{ width: "100%", color: "white" }}>
                    <Mui.LinearProgress
                      variant="determinate"
                      color={"inherit"}
                      value={50}
                      sx={{
                        backgroundColor: "black",
                        height: "10px",
                        borderRadius: 2,
                      }}
                    />
                  </Mui.Box>
                  <Mui.Typography sx={{ pt: 1 }} color="white">
                    <FontAwesomeIcon icon={faCaretUp} color={"white"} /> 16%
                    increase
                  </Mui.Typography>
                  <Mui.Typography color="white">On last week</Mui.Typography>
                  <Mui.Typography color="white" sx={{ pt: 3 }}>
                    View Issues &nbsp;{" "}
                    <FontAwesomeIcon icon={faCaretRight} color={"white"} />
                  </Mui.Typography>
                </Mui.Stack>
              </Mui.Box>
              <Mui.Box
                sx={{
                  backgroundColor: "rgb(26,165,124)",
                  background:
                    "linear-gradient(90deg, rgba(26,165,124,1) 0%, rgba(33,201,152,1) 100%)",
                  height: "48%",
                  borderRadius: "10px",
                  mt: 3,
                  p: 2,
                }}
              >
                <Mui.Stack direction="column">
                  <Mui.Typography color="#b4ecd3" fontSize={18}>
                    New Messages
                  </Mui.Typography>
                  <Mui.Typography
                    color="white"
                    variant="h4"
                    sx={{ pt: 2, pb: 2 }}
                  >
                    50
                  </Mui.Typography>
                  <Mui.Box sx={{ width: "100%", color: "white" }}>
                    <Mui.LinearProgress
                      variant="determinate"
                      color={"inherit"}
                      value={70}
                      sx={{
                        backgroundColor: "black",
                        height: "10px",
                        borderRadius: 2,
                      }}
                    />
                  </Mui.Box>
                  <Mui.Typography sx={{ pt: 1 }} color="white">
                    <FontAwesomeIcon icon={faCaretUp} color={"white"} /> 16%
                    increase
                  </Mui.Typography>
                  <Mui.Typography color="white">On last week</Mui.Typography>
                  <Mui.Typography color="white" sx={{ pt: 3 }}>
                    View Messages &nbsp;{" "}
                    <FontAwesomeIcon icon={faCaretRight} color={"white"} />
                  </Mui.Typography>
                </Mui.Stack>
              </Mui.Box>
            </Mui.Stack>
          </Mui.Grid>
          <Mui.Grid item xs={12} md={3}>
            <Mui.Stack
              direction="column"
              justifyContent="space-evenly"
              alignItems="stretch"
              height="100%"
              spacing={1}
            >
              <Mui.Box
                sx={{
                  backgroundColor: "rgb(131,71,247)",
                  background:
                    "linear-gradient(90deg, rgba(131,71,247,1) 0%, rgba(170,122,248,1) 100%)",
                  height: "48%",
                  borderRadius: "10px",
                  p: 2,
                }}
              >
                <Mui.Stack direction="column">
                  <Mui.Typography color="#e6d2ee" fontSize={18}>
                    Tasks Due Today
                  </Mui.Typography>
                  <Mui.Typography
                    color="white"
                    variant="h4"
                    sx={{ pt: 2, pb: 2 }}
                  >
                    5
                  </Mui.Typography>
                  <Mui.Box sx={{ width: "100%", color: "white" }}>
                    <Mui.LinearProgress
                      variant="determinate"
                      color={"inherit"}
                      value={5}
                      sx={{
                        backgroundColor: "black",
                        height: "10px",
                        borderRadius: 2,
                      }}
                    />
                  </Mui.Box>
                  <Mui.Typography sx={{ pt: 1 }} color="white">
                    <FontAwesomeIcon icon={faCaretUp} color={"white"} /> 16%
                    increase
                  </Mui.Typography>
                  <Mui.Typography color="white">On last week</Mui.Typography>
                  <Mui.Typography color="white" sx={{ pt: 3 }}>
                    View Tasks &nbsp;{" "}
                    <FontAwesomeIcon icon={faCaretRight} color={"white"} />
                  </Mui.Typography>
                </Mui.Stack>
              </Mui.Box>
              <Mui.Box
                sx={{
                  backgroundColor: "rgb(211,75,141)",
                  background:
                    "linear-gradient(90deg, rgba(211,75,141,1) 0%, rgba(218,101,160,1) 100%)",
                  height: "48%",
                  borderRadius: "10px",
                  mt: 3,
                  p: 2,
                }}
              >
                <Mui.Stack direction="column">
                  <Mui.Typography color="#e6d2ee" fontSize={18}>
                    Tasks Closed
                  </Mui.Typography>
                  <Mui.Typography
                    color="white"
                    variant="h4"
                    sx={{ pt: 2, pb: 2 }}
                  >
                    18
                  </Mui.Typography>
                  <Mui.Box sx={{ width: "100%", color: "white" }}>
                    <Mui.LinearProgress
                      variant="determinate"
                      color={"inherit"}
                      value={18}
                      sx={{
                        backgroundColor: "black",
                        height: "10px",
                        borderRadius: 2,
                      }}
                    />
                  </Mui.Box>
                  <Mui.Typography sx={{ pt: 1 }} color="white">
                    <FontAwesomeIcon icon={faCaretDown} color={"white"} /> 20%
                    decrease
                  </Mui.Typography>
                  <Mui.Typography color="white">On last week</Mui.Typography>
                  <Mui.Typography color="white" sx={{ pt: 3 }}>
                    View Tasks &nbsp;{" "}
                    <FontAwesomeIcon icon={faCaretRight} color={"white"} />
                  </Mui.Typography>
                </Mui.Stack>
              </Mui.Box>
            </Mui.Stack>
          </Mui.Grid>

          <Mui.Grid item xs={12} md={6}>
            <Mui.Card sx={{ border: "solid 1px #ddd", height: "100%", p: 2 }}>
              <Mui.Grid
                item
                xs={12}
                container
                sx={{ pt: 1, pl: 1, pb: 0, height: "100%" }}
              >
                <Mui.Grid item xs={12}>
                  <Mui.Stack direction="column" sx={{ pr: 1 }}>
                    <Mui.Typography variant="h6" fontWeight="bold">
                      <FontAwesomeIcon icon={faStar} color="orange" size="sm" />
                      &nbsp; Your Favourite Devices
                    </Mui.Typography>
                    <Mui.Typography variant="subtitle1" color="#ccc">
                      10 Devices favourited
                    </Mui.Typography>
                    <Mui.List>
                      <Mui.ListItem
                        sx={{ pb: 0, pl: 0 }}
                        secondaryAction={
                          <>
                            <Mui.IconButton edge="end" aria-label="delete">
                              <FontAwesomeIcon
                                icon={faHeart}
                                color={"lightgreen"}
                                size="lg"
                              />
                            </Mui.IconButton>
                          </>
                        }
                      >
                        <Mui.ListItemAvatar
                          sx={{
                            minWidth: "36px",
                            padding: "3px",
                            mr: 1,
                            borderRadius: "5px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faMicrosoft}
                            color={"#ccc"}
                            size="3x"
                          />
                        </Mui.ListItemAvatar>
                        <Mui.ListItemText
                          sx={{ p: 0 }}
                          primary={
                            <Mui.Typography fontWeight="bold">
                              Name of your favourited device with a link
                            </Mui.Typography>
                          }
                          secondary={
                            <>
                              <FontAwesomeIcon
                                icon={faCalendar}
                                color="orange"
                                size="sm"
                              />
                              &nbsp; Last modified on 21st March 2022
                            </>
                          }
                        />
                      </Mui.ListItem>
                      <Mui.ListItem
                        sx={{ pb: 0, pl: 0 }}
                        secondaryAction={
                          <>
                            <Mui.IconButton edge="end" aria-label="delete">
                              <FontAwesomeIcon
                                icon={faHeart}
                                color={"red"}
                                size="lg"
                              />
                            </Mui.IconButton>
                          </>
                        }
                      >
                        <Mui.ListItemAvatar
                          sx={{
                            minWidth: "36px",
                            padding: "3px",
                            mr: 1,
                            borderRadius: "5px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faLinux}
                            color={"#ccc"}
                            size="3x"
                          />
                        </Mui.ListItemAvatar>
                        <Mui.ListItemText
                          sx={{ p: 0 }}
                          primary={
                            <Mui.Typography fontWeight="bold">
                              Name of your favourited device with a link
                            </Mui.Typography>
                          }
                          secondary={
                            <>
                              <FontAwesomeIcon
                                icon={faCalendar}
                                color="orange"
                                size="sm"
                              />
                              &nbsp; Last modified on 21st March 2022
                            </>
                          }
                        />
                      </Mui.ListItem>
                      <Mui.ListItem
                        sx={{ pb: 0, pl: 0 }}
                        secondaryAction={
                          <>
                            <Mui.IconButton edge="end" aria-label="delete">
                              <FontAwesomeIcon
                                icon={faHeart}
                                color={"red"}
                                size="lg"
                              />
                            </Mui.IconButton>
                          </>
                        }
                      >
                        <Mui.ListItemAvatar
                          sx={{
                            minWidth: "36px",
                            padding: "3px",
                            mr: 1,
                            borderRadius: "5px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faWindows}
                            color={"#ccc"}
                            size="3x"
                          />
                        </Mui.ListItemAvatar>
                        <Mui.ListItemText
                          sx={{ p: 0 }}
                          primary={
                            <Mui.Typography fontWeight="bold">
                              Name of your favourited device with a link
                            </Mui.Typography>
                          }
                          secondary={
                            <>
                              <FontAwesomeIcon
                                icon={faCalendar}
                                color="orange"
                                size="sm"
                              />
                              &nbsp; Last modified on 21st March 2022
                            </>
                          }
                        />
                      </Mui.ListItem>
                      <Mui.ListItem
                        sx={{ pb: 0, pl: 0 }}
                        secondaryAction={
                          <>
                            <Mui.IconButton edge="end" aria-label="delete">
                              <FontAwesomeIcon
                                icon={faHeart}
                                color={"orange"}
                                size="lg"
                              />
                            </Mui.IconButton>
                          </>
                        }
                      >
                        <Mui.ListItemAvatar
                          sx={{
                            minWidth: "36px",
                            padding: "3px",
                            mr: 1,
                            borderRadius: "5px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faUbuntu}
                            color={"#ccc"}
                            size="3x"
                          />
                        </Mui.ListItemAvatar>
                        <Mui.ListItemText
                          sx={{ p: 0 }}
                          primary={
                            <Mui.Typography fontWeight="bold">
                              Name of your favourited device with a link
                            </Mui.Typography>
                          }
                          secondary={
                            <>
                              <FontAwesomeIcon
                                icon={faCalendar}
                                color="orange"
                                size="sm"
                              />
                              &nbsp; Last modified on 21st March 2022
                            </>
                          }
                        />
                      </Mui.ListItem>
                      <Mui.ListItem
                        sx={{ pb: 0, pl: 0 }}
                        secondaryAction={
                          <>
                            <Mui.IconButton edge="end" aria-label="delete">
                              <FontAwesomeIcon
                                icon={faHeart}
                                color={"orange"}
                                size="lg"
                              />
                            </Mui.IconButton>
                          </>
                        }
                      >
                        <Mui.ListItemAvatar
                          sx={{
                            minWidth: "36px",
                            padding: "3px",
                            mr: 1,
                            borderRadius: "5px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faRedhat}
                            color={"#ccc"}
                            size="3x"
                          />
                        </Mui.ListItemAvatar>
                        <Mui.ListItemText
                          sx={{ p: 0 }}
                          primary={
                            <Mui.Typography fontWeight="bold">
                              Name of your favourited device with a link
                            </Mui.Typography>
                          }
                          secondary={
                            <>
                              <FontAwesomeIcon
                                icon={faCalendar}
                                color="orange"
                                size="sm"
                              />
                              &nbsp; Last modified on 21st March 2022
                            </>
                          }
                        />
                      </Mui.ListItem>
                      <Mui.ListItem
                        sx={{ pb: 0, pl: 0 }}
                        secondaryAction={
                          <>
                            <Mui.IconButton edge="end" aria-label="delete">
                              <FontAwesomeIcon
                                icon={faHeart}
                                color={"lightgreen"}
                                size="lg"
                              />
                            </Mui.IconButton>
                          </>
                        }
                      >
                        <Mui.ListItemAvatar
                          sx={{
                            minWidth: "36px",
                            padding: "3px",
                            mr: 1,
                            borderRadius: "5px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faRedhat}
                            color={"#ccc"}
                            size="3x"
                          />
                        </Mui.ListItemAvatar>
                        <Mui.ListItemText
                          sx={{ p: 0 }}
                          primary={
                            <Mui.Typography fontWeight="bold">
                              Name of your favourited device with a link
                            </Mui.Typography>
                          }
                          secondary={
                            <>
                              <FontAwesomeIcon
                                icon={faCalendar}
                                color="orange"
                                size="sm"
                              />
                              &nbsp; Last modified on 21st March 2022
                            </>
                          }
                        />
                      </Mui.ListItem>
                    </Mui.List>
                  </Mui.Stack>
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Card>
          </Mui.Grid>

          <Mui.Grid item xs={12} md={6}>
            <Mui.Card>
              <Mui.CardHeader
                avatar={
                  <Mui.Avatar sx={{ backgroundColor: "white" }} aria-label="">
                    <FontAwesomeIcon
                      icon={faTasks}
                      color={"orange"}
                      size="lg"
                    />
                  </Mui.Avatar>
                }
                action={
                  <>
                    <Mui.Stack direction="row">
                      {/* <Mui.Box sx={{border:'solid', borderColor:'orange', borderWidth:'2px', mr:1, pt:'5px', pb:0, pl:'5px', pr:'5px',borderRadius:'5px' }}>
                          <Mui.Typography fontSize='0.8rem'>starting</Mui.Typography>
                          <Mui.CircularProgress variant="determinate" value={25} />
                        </Mui.Box>
                        <Mui.Box sx={{border:'solid', borderColor:'orange', borderWidth:'2px', mr:1, pt:'5px', pb:0, pl:'5px', pr:'5px',borderRadius:'5px' }}>
                          <Mui.Typography fontSize='0.8rem'>progress</Mui.Typography>
                          <Mui.CircularProgress variant="determinate" value={90} />
                        </Mui.Box>
                        <Mui.Box sx={{border:'solid', borderColor:'orange', borderWidth:'2px', mr:1, pt:'5px', pb:0, pl:'5px', pr:'5px',borderRadius:'5px' }}>
                          <Mui.Typography fontSize='0.8rem'>complete</Mui.Typography>
                          <Mui.CircularProgress variant="determinate" value={70} />
                        </Mui.Box> */}
                      {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="tasks on"
                          value={value}
                          onChange={(newValue) => {
                            setValue(newValue);
                          }}
                          renderInput={(params) => <Mui.TextField {...params} />}
                        />
                        </LocalizationProvider> */}
                    </Mui.Stack>
                  </>
                }
                title={"Tasks for 22nd March 2022"}
                subheader={`Total of 5 tasks`}
                sx={{
                  borderBottom: "solid",
                  borderBottomWidth: "1px",
                  borderBottomColor: "#eee",
                  p: 2,
                }}
              />
              <Mui.CardContent>
                <Mui.Stack direction="column" sx={{ pr: 1 }}>
                  <React.Fragment>
                    <Mui.Typography variant="body2">Started</Mui.Typography>
                    {
                      <Mui.Box sx={{ display: "flex", alignItems: "center" }}>
                        <Mui.Box sx={{ width: "100%", mr: 1 }}>
                          <Mui.LinearProgress
                            variant="determinate"
                            color={"info"}
                            value={50}
                            sx={{
                              backgroundColor: "#ccc",
                              height: "10px",
                              borderRadius: 2,
                            }}
                          />
                        </Mui.Box>
                        <Mui.Box sx={{ minWidth: 35 }}>
                          <Mui.Typography
                            variant="body2"
                            color="text.secondary"
                          >{`10%`}</Mui.Typography>
                        </Mui.Box>
                      </Mui.Box>
                    }
                  </React.Fragment>
                  <React.Fragment>
                    <Mui.Typography variant="body2">In Progress</Mui.Typography>
                    {
                      <Mui.Box sx={{ display: "flex", alignItems: "center" }}>
                        <Mui.Box sx={{ width: "100%", mr: 1 }}>
                          <Mui.LinearProgress
                            variant="determinate"
                            color={"warning"}
                            value={90}
                            sx={{
                              backgroundColor: "#ccc",
                              height: "10px",
                              borderRadius: 2,
                            }}
                          />
                        </Mui.Box>
                        <Mui.Box sx={{ minWidth: 35 }}>
                          <Mui.Typography
                            variant="body2"
                            color="text.secondary"
                          >{`90%`}</Mui.Typography>
                        </Mui.Box>
                      </Mui.Box>
                    }
                  </React.Fragment>
                  <React.Fragment>
                    <Mui.Typography variant="body2">Complete</Mui.Typography>
                    {
                      <Mui.Box sx={{ display: "flex", alignItems: "center" }}>
                        <Mui.Box sx={{ width: "100%", mr: 1 }}>
                          <Mui.LinearProgress
                            variant="determinate"
                            color={"success"}
                            value={50}
                            sx={{
                              backgroundColor: "#ccc",
                              height: "10px",
                              borderRadius: 2,
                            }}
                          />
                        </Mui.Box>
                        <Mui.Box sx={{ minWidth: 35 }}>
                          <Mui.Typography
                            variant="body2"
                            color="text.secondary"
                          >{`10%`}</Mui.Typography>
                        </Mui.Box>
                      </Mui.Box>
                    }
                  </React.Fragment>
                </Mui.Stack>

                <Mui.List>
                  <Mui.ListItem
                    sx={{ pb: 0, pl: 0 }}
                    secondaryAction={
                      <>
                        <Mui.Stack direction="row" spacing="2px">
                          <Mui.Avatar
                            sx={{ backgroundColor: "orange", color: "white" }}
                          >
                            S
                          </Mui.Avatar>
                          <Mui.Avatar
                            sx={{ backgroundColor: "red", color: "white" }}
                          >
                            DW
                          </Mui.Avatar>
                          <Mui.Avatar
                            sx={{ backgroundColor: "green", color: "white" }}
                          >
                            CS
                          </Mui.Avatar>
                        </Mui.Stack>
                      </>
                    }
                  >
                    <Mui.ListItemAvatar
                      sx={{
                        minWidth: "36px",
                        padding: "3px",
                        mr: 1,
                        borderRadius: "5px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPencil}
                        color={"#0288d1"}
                        size="2x"
                      />
                    </Mui.ListItemAvatar>
                    <Mui.ListItemText
                      sx={{ p: 0 }}
                      primary={
                        <Mui.Typography fontWeight="bold">
                          Work Issue item number 1
                        </Mui.Typography>
                      }
                      secondary={
                        <>
                          <FontAwesomeIcon
                            icon={faCalendar}
                            color="orange"
                            size="sm"
                          />
                          &nbsp; Last modified on 21st March 2022
                        </>
                      }
                    />
                  </Mui.ListItem>
                  <Mui.ListItem
                    sx={{ pb: 0, pl: 0 }}
                    secondaryAction={
                      <>
                        <Mui.Stack direction="row" spacing="2px">
                          <Mui.Avatar
                            sx={{ backgroundColor: "purple", color: "white" }}
                          >
                            AD
                          </Mui.Avatar>
                          <Mui.Avatar
                            sx={{ backgroundColor: "red", color: "white" }}
                          >
                            DW
                          </Mui.Avatar>
                          <Mui.Avatar
                            sx={{ backgroundColor: "green", color: "white" }}
                          >
                            CS
                          </Mui.Avatar>
                        </Mui.Stack>
                      </>
                    }
                  >
                    <Mui.ListItemAvatar
                      sx={{
                        minWidth: "36px",
                        padding: "3px",
                        mr: 1,
                        borderRadius: "5px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPencil}
                        color={"orange"}
                        size="2x"
                      />
                    </Mui.ListItemAvatar>
                    <Mui.ListItemText
                      sx={{ p: 0 }}
                      primary={
                        <Mui.Typography fontWeight="bold">
                          Name of your favourited device with a link
                        </Mui.Typography>
                      }
                      secondary={
                        <>
                          <FontAwesomeIcon
                            icon={faCalendar}
                            color="orange"
                            size="sm"
                          />
                          &nbsp; Last modified on 21st March 2022
                        </>
                      }
                    />
                  </Mui.ListItem>
                  <Mui.ListItem
                    sx={{ pb: 0, pl: 0 }}
                    secondaryAction={
                      <>
                        <Mui.Stack direction="row" spacing="2px">
                          <Mui.Avatar
                            sx={{ backgroundColor: "orange", color: "white" }}
                          >
                            S
                          </Mui.Avatar>
                          <Mui.Avatar
                            sx={{ backgroundColor: "red", color: "white" }}
                          >
                            DW
                          </Mui.Avatar>
                          <Mui.Avatar
                            sx={{ backgroundColor: "green", color: "white" }}
                          >
                            CS
                          </Mui.Avatar>
                        </Mui.Stack>
                      </>
                    }
                  >
                    <Mui.ListItemAvatar
                      sx={{
                        minWidth: "36px",
                        padding: "3px",
                        mr: 1,
                        borderRadius: "5px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPencil}
                        color={"orange"}
                        size="2x"
                      />
                    </Mui.ListItemAvatar>
                    <Mui.ListItemText
                      sx={{ p: 0 }}
                      primary={
                        <Mui.Typography fontWeight="bold">
                          Name of your favourited device with a link
                        </Mui.Typography>
                      }
                      secondary={
                        <>
                          <FontAwesomeIcon
                            icon={faCalendar}
                            color="orange"
                            size="sm"
                          />
                          &nbsp; Last modified on 21st March 2022
                        </>
                      }
                    />
                  </Mui.ListItem>
                  <Mui.ListItem
                    sx={{ pb: 0, pl: 0 }}
                    secondaryAction={
                      <>
                        <Mui.Stack direction="row" spacing="2px">
                          <Mui.Avatar
                            sx={{ backgroundColor: "orange", color: "white" }}
                          >
                            S
                          </Mui.Avatar>

                          <Mui.Avatar
                            sx={{ backgroundColor: "green", color: "white" }}
                          >
                            CS
                          </Mui.Avatar>
                        </Mui.Stack>
                      </>
                    }
                  >
                    <Mui.ListItemAvatar
                      sx={{
                        minWidth: "36px",
                        padding: "3px",
                        mr: 1,
                        borderRadius: "5px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPencil}
                        color={"info"}
                        size="2x"
                      />
                    </Mui.ListItemAvatar>
                    <Mui.ListItemText
                      sx={{ p: 0 }}
                      primary={
                        <Mui.Typography fontWeight="bold">
                          Name of your favourited device with a link
                        </Mui.Typography>
                      }
                      secondary={
                        <>
                          <FontAwesomeIcon
                            icon={faCalendar}
                            color="orange"
                            size="sm"
                          />
                          &nbsp; Last modified on 21st March 2022
                        </>
                      }
                    />
                  </Mui.ListItem>
                  <Mui.ListItem
                    sx={{ pb: 0, pl: 0 }}
                    secondaryAction={
                      <>
                        <Mui.Stack direction="row" spacing="2px">
                          <Mui.Avatar
                            sx={{ backgroundColor: "green", color: "white" }}
                          >
                            CS
                          </Mui.Avatar>
                        </Mui.Stack>
                      </>
                    }
                  >
                    <Mui.ListItemAvatar
                      sx={{
                        minWidth: "36px",
                        padding: "3px",
                        mr: 1,
                        borderRadius: "5px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPencil}
                        color={"info"}
                        size="2x"
                      />
                    </Mui.ListItemAvatar>
                    <Mui.ListItemText
                      sx={{ p: 0 }}
                      primary={
                        <Mui.Typography fontWeight="bold">
                          Name of your favourited device with a link
                        </Mui.Typography>
                      }
                      secondary={
                        <>
                          <FontAwesomeIcon
                            icon={faCalendar}
                            color="orange"
                            size="sm"
                          />
                          &nbsp; Last modified on 21st March 2022
                        </>
                      }
                    />
                  </Mui.ListItem>
                  <Mui.ListItem
                    sx={{ pb: 0, pl: 0 }}
                    secondaryAction={
                      <>
                        <Mui.Stack direction="row" spacing="2px">
                          <Mui.Avatar
                            sx={{ backgroundColor: "orange", color: "white" }}
                          >
                            S
                          </Mui.Avatar>
                          <Mui.Avatar
                            sx={{ backgroundColor: "red", color: "white" }}
                          >
                            DW
                          </Mui.Avatar>
                        </Mui.Stack>
                      </>
                    }
                  >
                    <Mui.ListItemAvatar
                      sx={{
                        minWidth: "36px",
                        padding: "3px",
                        mr: 1,
                        borderRadius: "5px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPencil}
                        color={"info"}
                        size="2x"
                      />
                    </Mui.ListItemAvatar>
                    <Mui.ListItemText
                      sx={{ p: 0 }}
                      primary={
                        <Mui.Typography fontWeight="bold">
                          Name of your favourited device with a link
                        </Mui.Typography>
                      }
                      secondary={
                        <>
                          <FontAwesomeIcon
                            icon={faCalendar}
                            color="orange"
                            size="sm"
                          />
                          &nbsp; Last modified on 21st March 2022
                        </>
                      }
                    />
                  </Mui.ListItem>
                </Mui.List>
              </Mui.CardContent>
              <Mui.CardActions disableSpacing>
                {/* <Mui.IconButton aria-label="add to favorites on dashboard">
                <FontAwesomeIcon icon={faStar} color={'grey'}   /> 
                </Mui.IconButton>
                <Mui.IconButton aria-label="share">
                  <FontAwesomeIcon icon={faBullhorn} color={'orange'}   /> 
                </Mui.IconButton> */}
              </Mui.CardActions>
            </Mui.Card>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.Grid>
    </>
  );
};

export { EngineerDashboardPage };
